<template>
    <div class="page wallet">
        <mu-refresh-control :refreshing="refreshing" :trigger="trigger" @refresh="refresh" />
        <pageTitle title='K币明细'></pageTitle>
        <div class="mycoin">
            我的K币
            <h2>{{wallet.KCoin}}</h2>
        </div>
        <div class="demo-refresh-container">
            <div class="list">
                <div class="item" v-on:click="deleteitem(item.logID)" v-for="item in coinRecords">
                    <div class="date">
                        {{item.Operate_Date | detailDate}}
                    </div>
                    <div>
                        <span class='strong'>{{item.Operate_Type_Display}}</span><br/>
                        <span class='detail'>备注:{{item.Operate_Remark | remark }}</span>
                    </div>
                    <div>
                        <span class='num'>{{item.Operate_Money | discount}}</span>
                    </div>
                </div>
            </div>
            <loadListTail mainTitle='暂无K币记录' mainIcon='noDetail' :noMore='loadState.stop' :isLoading='loadState.loading' :overZero='coinRecords.length > 0'  />
            <div class='loading' v-if='loadState.loading'>
                <img src="../../../static/LoadingBest.gif" />
            </div>
        </div>

        <!--弹出框 选择是否-->
        <mu-dialog :open="dialog" title="" @close="closeNO">
            <div style="color:#666666 ; margin-bottom:1.5vh">
                您真的要删除这条记录吗？
            </div>
            <table style="width:100%">
                <tr>
                    <td align="center">
                        <mu-flat-button slot="actions" @click="closeNO" primary="" label="取消" style="background-color:#cccccc ;color:white  " />
                    </td>
                    <td align="center">
                        <mu-flat-button slot="actions" @click="closeYES" label="确定" style="background-color:#27BA69 ;;color:white " />
                    </td>
                </tr>
            </table>
        </mu-dialog>
        <!--弹出框-->
        <mu-toast v-if="toast" v-bind:message="TellUser" @close="hideToast" id="alertline" />

    </div>
</template>

<script>
import api from '../../api'
import { mapMutations } from 'vuex'
import { mapGetters } from 'vuex'
import Scroll from '../../utils/loading'
import loadListTail from '../../components/loadListTail'

export default {
    data() {
        return {
            coinRecords: [],
            loadState: {},
            refreshing: false,
            trigger: null,
            // 弹出标签 选择是否
            dialog: false,
            // 弹出层
            toast: false,
            TellUser: '',
            scroll:null
        }
    },
    components:{
        loadListTail
    },
    activated() {
        this.scroll.addHandler()
    },
    mounted() {
        this.trigger = this.$el
        this.scroll = Scroll.Create(this,this.getData,10,1)
    },
    deactivated() {
        this.scroll.removeHandler()
    },
    methods: {
        ...mapMutations({
            setWallet: 'setG_walletInfo', setState: 'setG_userState'
        }),

        initData() {
            //清空显示数据
            this.coinRecords = []
            //初始化本页控制数据、分页参数
            this.scroll.refresh()
        },

        GetMyWallet() {
            this.$http.post(api.GetMyWallet()).then((res) => {
                if (res.Result) {
                    this.setWallet(res.Data);
                }
            })
        },

        getData() {
            var that = this
            var params = new this.URLSearchParam()
            params.append('pageIndex', this.pageParam.index)
            params.append('pageSize', 10)
            return new Promise(function(resolve, reject) {
                that.$http.post(api.getKCoinLog(), params.toParam()).then((res) => {
                    if (res.Result) {
                        var temp = res.Data;
                        resolve(temp.length);
                        that.coinRecords = that.coinRecords.concat(temp);
                    }
                    else {
                        resolve(null);
                        that.$router.push({ path: '/user/Login' })
                    }
                })
            })
        },
        refresh() {
            this.refreshing = true
            setTimeout(() => {
                this.refreshing = false
                this.initData()
            }, 2000)
        },

        // 弹出标签 选择是否
        deleteitem(val) {
            this.dialog = true;
            this.itemID = val;
        },
        
        closeYES( ) {
            this.dialog = false;

            var params = new this.URLSearchParam();
            params.append('logId', this.itemID);

            this.$http.post(api.DeleteCardMoneyDetail(), params.toParam()).then((res) => {
                
                if( res.Result){
                    this.TellUser = res.Data.message;
                    this.showToast();

                    this.initData()
                }
                else{
                    this.TellUser = res.Message.message;
                    this.showToast();
                }


            });
        },
        closeNO() {
            //  拒绝取消订单
            this.dialog = false;
        },
        // END 弹出标签 选择是否
        // 弹出层
        showToast() {
            this.toast = true
            if (this.toastTimer) clearTimeout(this.toastTimer)
            this.toastTimer = setTimeout(() => { this.toast = false }, 1000)
            if (this.TellUser == '未登录') {
                this.$store.dispatch('clearUser');
                this.toastTimer = setTimeout(() => { this.$router.push({ path: '/user/login' }); }, 1200)
            }
        },
        hideToast() {
            this.toast = false
            if (this.toastTimer) clearTimeout(this.toastTimer)
        },
        // 弹出层
    },
    computed: {
        ...mapGetters({
            wallet: 'g_walletInfo', loginInfo: 'g_loginInfo'
        })
    }
}
</script>


<style lang="less" scoped>
.WhiteKuang1 {
    margin-left: 3%;
    width: 94%;
    max-width: 480px;
    background-color: white;
    border-radius: 5px;
    z-index: 999999;
    position: absolute;
    top: 3%;
    font-size: 90%;
    transform-origin: 0px 0px 0px;
    opacity: 1;
    transform: scale(1, 1);
}


</style>



<style lang="less">
@import "../../assets/theme.less";
.demo-refresh-container {
    // width: 7.5rem;
    height: auto;
    -webkit-overflow-scrolling: touch;
    position: relative;
    user-select: none;
}

.mycoin {
    padding: 1.5em;
    color: black;
    text-align: center;
    font-size: 0.26rem;
    font-weight:bold;
    h2 {
        color: #FF5A5a;
        margin: 1px 0 0 0;
        font-size: 0.38rem;
    }
}

.list {
    width: 100%;
    background-color: white;
    .item {
        padding-left: 0.17rem;
        height: auto;
        display: flex;
        display: -webkit-flex;
        border-bottom: 1px solid #ECECEC;
        div {
            border-left: 1px solid #ECECEC;
            margin: auto;
            margin-left: 0.1rem;
            font-color: @textColor;
            display: inline-block;
        }
        div.date {
            width: 22%;
            height: 0.55rem;
            text-align: left;
            font-size: 0.24rem;
            border: none;
            line-height: 0.3rem;
        }
        div:nth-child(2) {
            width: 50%;
            line-height: 0.4rem;
            padding-left: 0.2rem;
            padding-top: 0.1rem;
            text-align: left;
            .detail {
                font-size: 0.22rem;
                color: @textColor;
            }
            .strong {
                font-weight: 500;
                color: @primaryBlack;
                font-size: 0.26rem;
            }
        }
        div:last-child {
            float: right;
            text-align: right;
            padding-right: 3.5%;
            width: 1.5rem;
            color: @darkerPrimaryColor;
            border: none;
            font-size: 0.36rem;
            .num {
                position: relative;
                margin: auto;
            }
        }
    }
}

.load {
    position: relative;
    text-align: center;
    padding: 1em;
    background-color: #ECECEC
}

.loading {
    text-align: center;
    div {
        padding: 1em;
        background-color: #ECECEC;
    }
}
</style>


// WEBPACK FOOTER //
// coinDetail.vue?3c48e369